import { BasePromoCodeListResponse, BasePromoCodeResponse, BaseResponse, PromoService } from '@api/backend';
import { PromoCodeRepository } from '@core/repositories/promocode.repository';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class PromoCodeWebRepository extends PromoCodeRepository {

  constructor(
    private promoService: PromoService,
  ) { super(); }

  public getList(): Observable<BasePromoCodeListResponse> {
    return this.promoService.getPromoCodesPromoGet();
  }

  public getValidatePromoCode(promoCode: string): Observable<BasePromoCodeResponse> {
    return this.promoService.promoValidatePromoValidatePromoCodeGet(promoCode);
  }

  public postApplyPromoCode(promoCode: string): Observable<BaseResponse> {
    return this.promoService.promoApplyPromoApplyPromoCodePost(promoCode);
  }
}